module.exports = __webpack_public_path__ + "static/img/1.3a3144d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/6/1.png
// module id = B9PB
// module chunks = 0